import { ItemNotFound } from '@/ItemNotFound';
import { ReactNode } from 'react';

export const NotFoundRedirectionWrapper = ({
  itemName,
  isItemNotFound,
  children,
}: {
  isItemNotFound: boolean;
  children: ReactNode;
  itemName: string;
}) => {
  return isItemNotFound ? <ItemNotFound itemName={itemName} /> : children;
};
